import router from './router';
import store from './store'
import { Loading } from 'element-ui'
import { startIdleLogout, stopIdleLogout } from '@/utils/idleLogout'

const whiteList = ['/login'] // no redirect whitelist

/**
 * 处理IFrame嵌套页面
 */
 function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    path = path.replace('/iframe/', '//')
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}


//使用钩子函数对路由进行权限跳转
router.beforeEach(async(to, from, next) => {
    document.title = `Mocasa Management System | ${to.meta.title}`;
      // if (to.path == '/login' || to.path == '/403' || to.path == '/500') {
      if (to.path == '/login' || to.path == '/500') {
        stopIdleLogout()
        next()
      } else {
        startIdleLogout(to.path)
        // handleIFrameUrl(to.path)
        // determine whether the user has obtained his permission roles through getInfo
        // const permissionCodeList = store.getters.permissionCodeList && store.getters.permissionCodeList.length > 0
        const menuRouteLoaded = store.getters.menuRouteLoaded
        if (menuRouteLoaded) {
          next()
        } else {
          // 增加loading
          // const loading = Loading.service({ fullscreen: true })
          try {
            // get user info
            // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
            // try {
              const { roleNames, permissionCodeList } = await store.dispatch('user/getInfo')
              // console.log(roleName, permissionCodeList)

              // generate accessible routes map based on roles
              const accessRoutes = await store.dispatch('permission/generateRoutes', {roleNames, permissionCodeList})
              
              // dynamically add accessible routes
              router.addRoutes(accessRoutes)
              // accessRoutes.forEach(route => {
              //   router.addRoute(route);
              // });

              // loading.close()
              // 关闭loading
            // } catch (error) {
            //   loading.close()
            // }
            // console.log(router)

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({ ...to, replace: true })
          } catch (error) {
            // loading.close()
            if (error.code == 501) {
              next(`/login`)
            } else if (error.code == 51) {
              next(`/403`)
            } else {
              next(`/500`)
            }
          }
        }
      }
});
